import { lazy } from 'react';

export { default as ImageDefaultProjectImage } from './default_project_image.png';

export { default as LogoSymbol } from './logo_symbol';

export const Landscape = lazy(() => import('./image_landscape'));
